export default __webpack_public_path__ + "static/media/commitment-sanity.2b47ec73.png";